import loadable from '@loadable/component';
import loading from 'Components/asyncLoading/asyncLoading';

export default loadable(() => import(/* webpackChunkName: "ItemNotifications" */'./Notifications'), {
    fallback: loading()
});
